<template>
    <div class="card">
        <h4 class="card-header">
            <slot>
                <LinkLabel no-link :link="$t('links.default')" />
            </slot>
        </h4>

        <ul class="list-group list-group-flush">
            <li v-if="links.length === 0" key="empty-list" class="list-group-item text-center">
                <em class="text-muted">
                    {{ $t('links.empty') }}
                </em>
            </li>

            <li
                v-for="link in links"
                v-else
                :key="link.id"
                class="list-group-item">
                <LinkLabel :link="link" />
            </li>
        </ul>
    </div>
</template>

<script>
import LinkLabel from '@/js/components/link/LinkLabel';

export default {
    name: 'LinksCard',

    components: {LinkLabel},

    props: {
        links: {type: Array, default: () => []},
    },
};
</script>
